import { Component, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HOME_BOXES, HomeBox } from '../../core/constants/general.constants';
import { RouterModule } from '@angular/router';
import { PermissionService } from '../../core/services/permission.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, FontAwesomeModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

  homeBoxes: HomeBox[] = [];

  constructor(private permissionService: PermissionService) {}

  ngOnInit() {
    this.homeBoxes = HOME_BOXES.filter(box =>
      this.permissionService.hasPermission(box.requiredPermission)
    );
  }
}
